import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IconRegistryService } from './utilities/icon-registry.service';
import { CryptographyService } from './services/cryptography/cryptography.service';
import { PosthogService } from './services/posthog.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'aip-checkout-fe';

  private token!: string | null;

  constructor(
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private readonly iconService: IconRegistryService,
    private readonly cryptographyService: CryptographyService,
    private readonly posthogService: PosthogService
  ) {
    this.iconService.setIcons();
  }

  ngOnInit(): void {
    console.error('app component >> ', this.router.url);
    // this.cryptographyService.initialize();
  }
}
